export const URL_SELL_WITH_FLIP = '/sellwithflip'
